import { jsonMember, jsonObject } from 'typedjson';
import { Nillable } from '@web/utils';

@jsonObject
export class AdminShippingSettingsResponse {
  @jsonMember(Number)
  public readonly labelFetchRetries!: number;

  @jsonMember(Number)
  public readonly labelsInFile!: number;

  @jsonMember(String)
  public readonly senderFirstName!: string;

  @jsonMember(String)
  public readonly senderLastName!: string;

  @jsonMember(String)
  public readonly senderEmail!: string;

  @jsonMember(String)
  public readonly senderPhonePrefix!: string;

  @jsonMember(String)
  public readonly senderPhoneNumber!: string;

  @jsonMember(String)
  public readonly senderCompany?: Nillable<string>;

  @jsonMember(String)
  public readonly warehouseCountryCode!: string;

  @jsonMember(String)
  public readonly warehouseCity!: string;

  @jsonMember(String)
  public readonly warehouseStreet!: string;

  @jsonMember(String)
  public readonly warehousePostCode!: string;

  @jsonMember(String)
  public readonly warehouseHouseNumber!: string;

  @jsonMember(String)
  public readonly warehouseFlatNumber?: Nillable<string>;
}
